import { css } from '@/styled-system/css';

export const tooltipArrowStyles = css.raw({
  fill: 'bg.elevated.mediumShadow',
});
